export const cldUrl = (url, width, quality = "auto:eco") => {
  if (
    !url ||
    !url.includes("/res.cloudinary.com/") ||
    !url.includes("/upload/")
  ) {
    return url;
  }
  return url
    .replace("/upload/", `/upload/c_limit,w_${width},f_auto,q_${quality}/`)
    .replace(/\.(webp|jpg|jpeg|png)$/i, "");
};
